import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const RothIRA: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        // Override viewBox & strokeWidth, since this is a solid icon
        <IconSVG viewBox="0 0 24 24" strokeWidth={0} {...props}>
            <mask
                id="mask0_248_20261"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <rect width="24" height="24" rx="12" fill="currentColor" />
            </mask>
            <g mask="url(#mask0_248_20261)">
                <IconPath
                    d="M15.1045 -6.39844L-4.64638 13.3524"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    {...pathProps}
                />
                <IconPath
                    d="M17.0479 -4.45508L-2.70302 15.2958"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    {...pathProps}
                />
                <IconPath
                    d="M20.9326 -0.570312L1.18175 19.1806"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    {...pathProps}
                />
                <IconPath
                    d="M24.8184 3.31641L5.06749 23.0673"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    {...pathProps}
                />
                <IconPath
                    d="M18.9902 -2.51367L-0.760637 17.2372"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    {...pathProps}
                />
                <IconPath
                    d="M22.876 1.37109L3.12511 21.122"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    {...pathProps}
                />
                <IconPath
                    d="M26.7607 5.25977L7.00987 25.0106"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    {...pathProps}
                />
                <IconPath
                    d="M28.7041 7.20312L8.95323 26.954"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    {...pathProps}
                />
                <IconPath
                    d="M30.6465 9.14453L10.8956 28.8954"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    {...pathProps}
                />
            </g>
            <rect
                x="2"
                y="2"
                width="20"
                height="20"
                rx="10"
                stroke="currentColor"
                strokeWidth="4"
            />
        </IconSVG>
    );
};
